import { takeEvery, put, call } from "redux-saga/effects";
import { ADD_TRAINING, ASSIGN_TRAININGS, DELETE_TRAINING_LINK, GET_TRAININGS_LIST, UPDATE_TRAINING_LINK } from "./actionTypes";
import {
  addTrainingFail,
  addTrainingSuccess,
  assignTrainingFail,
  assignTrainingSuccess,
  deleteTrainingFail,
  deleteTrainingSuccess,
  getTrainingListFail,
  getTrainingListSuccess,
  updateTrainingFail,
  updateTrainingSuccess,
} from "./action";
import { onAddingTraining, onGettingTraining, onUpdatingTraining, onDeletingTraining, onAssigningTraining } from "helpers/fakebackend_helper";
import showToast from "common/Notification";
import { responseHandler } from "common/CommanFunction";
const toastTitle = "Training";

function* onAddTraining({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onAddingTraining, data);
    yield call(responseHandler, toastTitle, response, addTrainingSuccess, addTrainingFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(addTrainingFail(error));
    showToast("error", "Training", error);
  }
}

function* onAssignTraining({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onAssigningTraining, data);
    yield call(responseHandler, toastTitle, response, assignTrainingSuccess, assignTrainingFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(assignTrainingFail(error));
    showToast("errror", "Training", error);
  }
}

function* onGetTrainingList({ payload: data }) {
  try {
    const response = yield call(onGettingTraining, data);
    yield put(getTrainingListSuccess(response));
  } catch (error) {
    yield put(getTrainingListFail(error));
    showToast("errror", "Training", error);
  }
}

function* onUpdateTraining({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onUpdatingTraining, data);
    yield call(responseHandler, toastTitle, response, updateTrainingSuccess, updateTrainingFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(updateTrainingFail(error));
    showToast("errror", "Training", error);
  }
}

function* onDeleteTraining({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onDeletingTraining, data);
    yield call(responseHandler, toastTitle, response, deleteTrainingSuccess, deleteTrainingFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(deleteTrainingFail(error));
    showToast("errror", "Training", error);
  }
}

function* TrainingSaga() {
  yield takeEvery(ADD_TRAINING, onAddTraining);
  yield takeEvery(GET_TRAININGS_LIST, onGetTrainingList);
  yield takeEvery(UPDATE_TRAINING_LINK, onUpdateTraining);
  yield takeEvery(DELETE_TRAINING_LINK, onDeleteTraining);
  yield takeEvery(ASSIGN_TRAININGS, onAssignTraining);
}

export default TrainingSaga;
